import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=4c10c3b2&scoped=true&"
import script from "./Faq.vue?vue&type=script&lang=js&"
export * from "./Faq.vue?vue&type=script&lang=js&"
import style0 from "./Faq.vue?vue&type=style&index=0&id=4c10c3b2&lang=scss&scoped=true&"
import style1 from "./Faq.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c10c3b2",
  null
  
)

export default component.exports